import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    // console.log("Hello, AuthorsController!", this.element);
  }

  toggle(event) {
    const row_wrapper= event.target.closest('.form-group');
    // console.log(`Toggle: row wrapper: ${row_wrapper}`);
    const author_value= event.target.value;
    const new_field= row_wrapper.nextElementSibling;
    if ( author_value==undefined || author_value.length==0) {
      // Geen waarde ingegeven, verberg alle volgende auteursvelden
      new_field.classList.add('hide');
    } else {
      // Directly set focus on new input field
      if (new_field && new_field.classList.contains('hide')) {
        new_field.classList.remove('hide');
        new_field.querySelector('input.autocomplete').focus();
      }

    }
  }
}
